import HappyCircleArrowRight from '@stencil/icons/src/HappyCircleArrowRight/HappyCircleArrowRight';

import * as S from './PackageFeatureCard.styles';

const PackageFeatureCard = ({
  inclusionsListToShow = [],
  handleClick,
  onPackageLoad = () => {},
  isDweb = false,
}) => {
  onPackageLoad();
  return (
    <S.MainOuterWrapper onClick={handleClick}>
      <S.MainWrapper>
        <S.HeaderWrapper>
          <S.HeaderText>ELITE PACKAGE</S.HeaderText>
          <HappyCircleArrowRight height="2.5rem" width="2.5rem" />
        </S.HeaderWrapper>
        <S.ListWrapper isDweb={isDweb}>
          {inclusionsListToShow.slice(0, 3).map(item => (
            <S.ListItem key={item?.id}>
              {!!item?.iUrl && (
                <S.ListIconWrapper>
                  <img src={item?.iUrl} alt="icon" />
                </S.ListIconWrapper>
              )}
              {!!item?.text && <S.ListItemDesc dangerouslySetInnerHTML={{__html: item?.text}} />}
            </S.ListItem>
          ))}
        </S.ListWrapper>
      </S.MainWrapper>
    </S.MainOuterWrapper>
  );
};

export default PackageFeatureCard;
